// removed by extract-text-webpack-plugin
module.exports = {"message":"email-registration__message___37M_w","button":"email-registration__button___2xOWo","fullName":"email-registration__fullName___36rpv","toolTipEmailRegistration":"email-registration__toolTipEmailRegistration___xB_FX","toolTipPasswordToolbox":"email-registration__toolTipPasswordToolbox___sK1NK"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/auth/email-registration/email-registration.scss
// module id = 1245
// module chunks = 0